import { Dispatch } from 'redux';

import { getLoginVisits } from './api/getLoginVisits';
import { getProfileData } from './api/getProfileData';
import { getProfileDataByIntentId } from './api/getProfileDataByIntentId';
import { ProfileData, ProfileVisits } from './interfaces/Profile';

export const PROFILE_SET_DATA = 'Profile/set';
export const PROFILE_RESET_DATA = 'Profile/reset';
export const PROFILE_SET_LOADING = 'Profile/loading';
export const PROFILE_SET_VISITS = 'Profile/visits';
export const PROFILE_RESET_VISITS = 'Profile/resetVisits';

export const loadingProfile = (
  loading: boolean,
): { type: typeof PROFILE_SET_LOADING; payload: { loading: boolean } } => ({
  type: PROFILE_SET_LOADING,
  payload: { loading },
});

export const setProfileData = (
  session: unknown,
): { type: typeof PROFILE_SET_DATA; payload: { session: any } } => ({
  type: PROFILE_SET_DATA,
  payload: { session },
});

export const unsetProfileData = (): { type: typeof PROFILE_SET_LOADING } => ({
  type: PROFILE_SET_LOADING,
});

export const setProfileVisits = (
  type: string,
  { visits }: ProfileVisits,
): { type: typeof PROFILE_SET_VISITS; payload: { type: string; visits: any } } => ({
  type: PROFILE_SET_VISITS,
  payload: { type, visits },
});

export const unsetProfileVisits = (
  type: string,
): { type: typeof PROFILE_RESET_VISITS; payload: { type: string } } => ({
  type: PROFILE_RESET_VISITS,
  payload: { type },
});

export const setBrowserTitleEmployee = (profileData: ProfileData) => (): void => {
  document.title = `# ${profileData?.caseId} | ${profileData?.lastName}, ${profileData?.firstName} | Home`;
};

export const loadProfile =
  () =>
  // eslint-disable-next-line unicorn/consistent-function-scoping
  async (dispatch: Dispatch): Promise<void> => {
    //
    const profileData = await getProfileData();
    //
    dispatch(setProfileData(profileData));
  };

export const loadProfileByIntentId =
  (intentId: string) =>
  async (dispatch: Dispatch): Promise<void> => {
    //
    const profileData = await getProfileDataByIntentId(intentId);
    //
    dispatch(setProfileData(profileData));

    if (profileData) {
      setBrowserTitleEmployee(profileData);
    }
  };

export const onSetProfileVisits =
  (reqType: string, visitType: string, method: string) =>
  async (dispatch: Dispatch): Promise<void> => {
    const profileVisits = await getLoginVisits(reqType, method);
    //

    if (profileVisits) {
      dispatch(setProfileVisits(visitType, profileVisits));
    }
  };
